import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const customerApi = createApi({
  reducerPath: 'customerApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  tagTypes: ['Customer', 'CustomerList'],
  endpoints: () => ({})
})

export default customerApi
